import React, { Component } from 'react';
import { Zoom, Fade, Slide } from "react-reveal";

export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1><Zoom>Check Out Some of My Works.</Zoom></h1>
            <Slide bottom cascade>
          <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
          {
            resumeData.portfolio && resumeData.portfolio.map((item)=>{
              return(
                <div className="columns portfolio-item" key={item.name}>
                    <a href={item.link} target="blank">
                  <div className="item-wrap">
                      <img src={`${item.imgurl}`} alt="Snapshot" className="item-img"/>
                      <div className="overlay">
                        <div className="portfolio-item-meta">
                          <h5>{item.name}</h5>
                          <p>{item.description}</p>
                        </div>
                      </div>
                  </div>
                    </a>
                </div>
              )
            })
          }
          </div>
          </Slide>
        </div>
      </div>
  </section>
        );
  }
}